import { Component, Input, OnInit } from '@angular/core';
import { TCenter } from '@shared/interfaces/TCenter';
import { TProject } from '@shared/interfaces/TProject';
import { EChartsOption } from 'echarts';
import { TreatmentCenter, TreatmentItem } from 'src/app/interfaces/treatment-used-table-data.interface';
import { KamReportsService } from '../../services/kam-reports.service';

@Component({
  selector: 'app-chart-treatment-goals',
  templateUrl: './chart-treatment-goals.component.html',
  styleUrls: ['./chart-treatment-goals.component.scss']
})
export class ChartTreatmentGoalsComponent implements OnInit {
  @Input() project: TProject;
  options: EChartsOption;

  constructor(
    private _kamReportsService: KamReportsService,
  ) {}

  get centers(): TCenter[] { return this._kamReportsService.allCenters; }

  ngOnInit(): void {
    const treatmentGoals: TreatmentItem[] = this.getTreatmentGoals();
    this.options = this.getChartOptions(treatmentGoals);
  }

  getTreatmentGoals(): TreatmentItem[] {
    // build TreatmentCenter[]
    const treatmentGoals: string[] = this.project.treatment_goals.map(goal => goal.name);
    let treatmentData: TreatmentCenter[] = [];
    this.centers.forEach(center => {
      const projectData = center.projectsData.filter(pd => pd.projectId === this.project.id)[0];
      if (projectData.treatment_goals_enabled?.length) {
        treatmentData.push({
          name: center.c_name || center.c_original_name,
          total: 0,
          items: treatmentGoals.map((goal, index) => ({ name: goal, count: projectData.treatment_goals_enabled[index] ? 1 : 0 })),
        });
      }
    });
    // sum all
    const goals: TreatmentItem[] = treatmentGoals.map(goal => ({ name: goal, count: 0 }));
    treatmentData.forEach(td => {
      td.items.forEach((item, index) => {
        goals[index].count += item.count;
      });
    });
    return goals;
  }

  getChartOptions(treatmentGoals: TreatmentItem[]): EChartsOption {
    const result: EChartsOption = {
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        orient: 'horizontal',
        top: 'top',
        bottom: 'auto',
        left: 'center',
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'value',
        boundaryGap: [0, 0.01]
      },
      yAxis: {
        type: 'category',
        data: treatmentGoals.map(item => item.name),
      },
      series: [
        {
          // name: 'Treatment goals', // '1. quarter 2025',
          type: 'bar',
          data: treatmentGoals.map(item => item.count),
        },
        // {
        //   name: '2. quarter 2025',
        //   type: 'bar',
        //   data: [100, 150, 200, 250, 300, 350]
        // }.
      ]
    };
    return result;
  }
}
